"use client";

import { useState, useEffect } from "react";
import Link from "next/link";
import BlosmLogo from "./BlosmLogo";

const heroImage = "/images/salon-interior.webp";

export default function Hero() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={heroImage}
          alt=""
          className="w-full h-full object-cover animate-slow-zoom"
        />
      </div>

      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/70 z-10" />

      {/* Content */}
      <div className={`relative z-20 max-w-5xl mx-auto px-6 text-center transition-all duration-1000 ${loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <p className="text-amber-200/90 text-sm uppercase tracking-[0.4em] mb-6 animate-fade-in-up">
          Perth&apos;s Women-Only Salon
        </p>
        <div className="mb-6">
          <span className="block font-display text-5xl md:text-7xl lg:text-8xl font-semibold tracking-wide uppercase logo-blosm-dark drop-shadow-2xl">
            BLOSM
          </span>
          <span className="block font-sans text-sm md:text-base uppercase tracking-[0.4em] text-white/95 mt-2">
            HAIR & BEAUTY
          </span>
        </div>
        <p className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto mb-12 leading-relaxed">
          Where elegance meets expertise. Experience transformative beauty in a sanctuary designed exclusively for women.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="https://blosmhairandbeauty.gettimely.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 px-10 py-4 bg-amber-500 text-white font-medium tracking-wide hover:bg-amber-600 transition-all duration-300 shadow-lg hover:shadow-amber-500/30"
          >
            Book Appointment
          </a>
          <Link
            href="/services"
            className="inline-flex items-center justify-center gap-2 px-10 py-4 border-2 border-white/80 text-white font-medium tracking-wide hover:bg-white/10 transition-all duration-300"
          >
            Our Services
          </Link>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-24 left-1/2 -translate-x-1/2 z-20 hidden md:block">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center pt-2">
          <div className="w-1 h-2 bg-white/70 rounded-full animate-bounce" />
        </div>
      </div>
    </section>
  );
}
